import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
import '../../node_modules/jquery-parallax.js/parallax.min.js'

import AOS from 'aos'
import throttle from 'lodash/throttle'
import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange, } from './_lazy-load'
import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad'

import { alignMegaMenus, appendMegaMenus } from './_megamenus'
// import { searchOverlay } from './_search-overlay'
import { postTabs } from './_flexible-post-tabs'

import './_skip-link-focus-fix'
import './_acf-map'
import './_fixed-header'
import './_header-height'
import './_hero-slider'
import './_notification'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
import './_faqs_accordion'
import './_ie'
// import './_fragmentURLs'
// import unorphan from 'unorphan'

// Foundation
$(document).foundation();

// Inline SVG
inlineSVG();
inlineSVG('._svg');

// Smooth Scroll on page load
smoothScrollOnPageLoad();

// DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {
    lazyImages();
    lazyBackgrounds();
    lazyVideos();
    lazyOembeds();
    lazyInterchange();
    
    setTimeout( () => {
        // Mega Menus
        appendMegaMenus();
        alignMegaMenus();
        
        // Sub Nav
        centerMobileSubNav();

        // Sub Nav
        // centerMobileSubNav( $('.sub-navigation__scroll-container > .menu .menu-item.active a') );

    }, 500 );
    
}, false);

// Scroll
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyOembeds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );

// Onload
window.onload = () => {};

// AOS
AOS.init();


// Trigger resize to activate slider
$('.tabs').on('change.zf.tabs', function (event, activeTab) {
    setTimeout( function() {
        // 'setPosition' is like trigger a resize on the browser window
        // so slick recalculates is dynamic slide widths 
        $( '.testimonials__slider, .post-tabs__slider' ).slick("setPosition");
        $( '.js-slider' ).slick("setPosition");
    }, 10);
});


// Sub Nav
var subnav_menus = [],
    $subnav_submenus = $('.sub-navigation .menu .menu-item-has-children .sub-menu');

if ( $subnav_submenus.length ) {
    
    // Add submenus to an array
    $subnav_submenus.each( function(i) {

        subnav_menus[i] = $(this).get(0).outerHTML;
        
        $(this)
            .before(`
                <a class="sub-navigation__reveal-button" href="#submenu-panel-${i}">
                    <i aria-hidden class="fas fa-angle-down"></i>
                </a>
            `)
            .parent().addClass('has-submenu-button');
        
        //$(this).remove();

    } );
    
    // Store the sub menus in panels within .js-submenus-container
    let $submenus_container =  $('.js-submenus-container');
    
    $(subnav_menus).each( function(i) {
        
        let submenu = this;

        $submenus_container.get(0).innerHTML += `<div id="submenu-panel-${i}" class="submenu-panel">${submenu}</div>`;

    } );

    var _ctrl = false;
    var _i = '';

    $( '.sub-navigation__reveal-button' ).on( 'click', function( event ) {
        
        event.preventDefault();

        var $submenuPanel = $('.submenu-panel'),
            parentIndex = $(this).parent().index(),
            activePanel = $submenuPanel.eq(parentIndex);

        if (!_ctrl) {
            activePanel.slideDown();
            $(this).addClass('is-active');
            _i = parentIndex;
            _ctrl = true;
        } else if (!!_ctrl && _i == parentIndex) {
            activePanel.slideUp();
            $(this).removeClass('is-active');
            activePanel.parent().css('min-height', 'auto');
            _ctrl = false;
        } else if (!!_ctrl && _i !== parentIndex) {
            let h = activePanel.parent().outerHeight();
            let _this = $(this);
            activePanel.parent().css('min-height', h + 'px');
            $submenuPanel.slideUp(150, function() {
                $( '.sub-navigation__reveal-button' ).removeClass('is-active');
            });
            setTimeout(
                function() {
                    activePanel.slideDown();
                    _this.addClass('is-active');
                    _i = parentIndex;
                    _ctrl = true;
                },
                400
            );
        }

    } );

} else {

    $('.js-submenus-container').attr('aria-hidden', 'true');

}


// Detect Postition Sticky - Add a class to the sticky element when it becomes sticky

function detectPositionSticky( selector = '.sub-navigation' ) {
    var _$stickies = [].slice.call(document.querySelectorAll(selector));

    _$stickies.forEach(function(_$sticky){
        if (CSS.supports && CSS.supports('position', 'sticky')) {
            apply_sticky_class(_$sticky);

            window.addEventListener('scroll', function(){
                apply_sticky_class(_$sticky);
            })
        }
    })

    function apply_sticky_class(_$sticky){
        var currentOffset = _$sticky.getBoundingClientRect().top;
        var stickyOffset = parseInt( getComputedStyle(_$sticky).top.replace('px','') );
        var isStuck = currentOffset <= stickyOffset;

        if (isStuck) {
            _$sticky.classList.add('js-is-sticky');
        } else {
            _$sticky.classList.remove('js-is-sticky');
        }
    }
}

detectPositionSticky();


// Remove Orphans 
// unorphan( $('h3, body.home') );


// HACK: 

window.onload = function() {
    const $tileOverlay = $('.tile.tile--overlay');

    if ( $tileOverlay.length > 0 ) {
        
        $tileOverlay.each( function(i) {
            let icon = $(this).find('.tile__icon');
            if ( icon.length > 0 ) {
                $(this).addClass('js-has-icon');
            }
        });

    }
};


// AJAX Load More - When is_tax('market_category'), set the term for each post preview.  

jQuery( function($) {
    
    $.fn.almComplete = function(alm){
        var is_tax_market = $('body').hasClass('tax-market_category');
       
        if ( is_tax_market ) {
            let term = $('.post-previews').attr('data-term');
            $('.post-previews__post').each( function( i ) {
                $(this).find('.post-previews__current-term').html(term);
            } );
        }
        
        setTimeout( function() {
            console.log('load ajax load more images');
            lazyImages();
        }, 100 );
    };

    
    // ** Update the Market and Service menus to be open to the current navigation item 
    
    function openSubNavigationOnLoad () {
        let $sub_navigation = $('.sub-navigation'),
            current_menuitem_query = '.current-menu-item .sub-navigation__reveal-button',
            current_parent_query = '.current-menu-parent .sub-navigation__reveal-button';

        if ( $sub_navigation.length > 0 && $sub_navigation.find( current_menuitem_query ).length > 0 ) {
            setTimeout(function() {
                $sub_navigation.find( current_menuitem_query ).get(0).click();
            }, 500);
        } else if ( $sub_navigation.length > 0 && $sub_navigation.find( current_parent_query ).length > 0 ) {
            setTimeout(function() {
                $sub_navigation.find( current_parent_query ).get(0).click();
            }, 500);
        }
    }
    
    if ( !$('body').hasClass('is-mobile') ) {
        openSubNavigationOnLoad();
    }

});


// ** Center Horizontal Navigation 

const centerMobileSubNav = ( 
    $target = $('.sub-navigation__scroll-container > .menu .menu-item.active a, .sub-navigation__scroll-container > .menu .menu-item.current-menu-parent a'), 
    $scrollWrapper = $('.sub-navigation__scroll-container'),
    $centerActive = true 
) => {
    const $NAV_LIST = $scrollWrapper;
    let el = $target;

    if ( $NAV_LIST.length > 0 && el.length > 0 ) {
        
        let el_width = el.innerWidth();
        let offset = $target.offset().left;
        let visible_width = $NAV_LIST.width();
        let scrollOffset = $NAV_LIST.scrollLeft();
        var _onComplete = false; 

        if ( $NAV_LIST.length > 0 && offset < visible_width / 2 ) {
            let math = ( visible_width / 2 - ( offset + el_width ) ) + ( el_width / 2 ); 
            if ( $centerActive === false ) {
                math = ( offset - 15 );
            }
            let scroll_amount = scrollOffset + (math * -1); // math * -1 to create a negative value to scroll right
            $NAV_LIST.animate( { scrollLeft: scroll_amount }, 500);
        } 

        else if ( $NAV_LIST.length > 0 && offset > visible_width / 2 ) {
            let math = ( offset - ( visible_width / 2 ) ) + ( el_width / 2 ); 
            if ( $centerActive === false ) {
                math = ( offset - 15 );
            }
            let scroll_amount = scrollOffset + math;
            $NAV_LIST.animate( { scrollLeft: scroll_amount }, 500);
        }

    }

}

// ** Add link to tile--overlay if is does not contain a link list of categories

function addLinkToOverlayTile() {
    var $overlayTiles = $( '.tile.tile--overlay', '.flexible-tiles' );

    if ( $overlayTiles.length > 0 ) {
        
        $overlayTiles.each( function( i, el ) {
            
            var $tile = $(this),
                tileLink = $tile.find( '.tile__header--top' ).attr('href'),
                tileLinkList = $tile.find( '.tile__link-list' );

            if ( tileLinkList.html() && tileLinkList.html().trim() == '' ) {
                console.log('tile-' + i ,tileLinkList.html() );
                
                $tile.addClass('js-onclick-link');

                $tile.on( 'click', function() {
                    window.location.href = tileLink;
                } );
            }

        } );

    }
}

addLinkToOverlayTile();

// IE Detection

if ( !sessionStorage.getItem('nv_ie_detect') 
     && $('body').hasClass('is-ie') 
     && !$('body').hasClass('is-edge') 
) {
    let $ie_warning = $('#ie11-warning');
    
    if ( $ie_warning.length > 0 ) {
        
        $ie_warning.get(0).style.display = 'block';

        $ie_warning.attr('aria-hidden', 'false');

        $ie_warning.find('a').on( 'click', function( event ) {
            sessionStorage.setItem('nv_ie_detect', 'true')
        } );
    }

}


// iOS 10 Detect
function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
}

// var ver = iOSversion();

// if ( ver[0] ) {
//     console.log('Is iOS ' + ver[0]);
//     $('body').addClass(`js-is-ios--${ver[0]}`);
// }

// if ( ver[0] == 10 ) {
    
//     if ( !sessionStorage.getItem('ios10_detect') && ( $('body').hasClass('is-ios') && $('body').hasClass('is-tablet') ) ) {
        
//         $('#content').prepend(`
//             <style>
//                 @media screen and (orientation: portrait) {
//                     #iOS-10-warning {
//                         display: none;
//                     }
//                 }
//             </style>
//             <div id="iOS-10-warning" style="padding: 30px; position: relative; z-index: 10000; background-color: #F3f3f3">
//                 <div class="grid-x grid-padding-x align-center padding-large">
//                     <div class="cell small-12 text-center">
//                         <h2 class="padding-bottom--tiny">You are using iOS 10 or lower which is not supported by this website.</h2>
//                         <p class="text-center margin-bottom--small size-20">This means that some functionaity may not work as intended. This may result in strange behaviours when browsing. Please upgrade the version of iOS on this device for the best viewing experience.</p>
//                         <a class="button large primary uppercase" href="https://support.apple.com/en-ca/HT204204" target="_blank">Learn how to upgrade</a>
//                         <br><br>
//                         <a onclick="javascript: document.getElementById('iOS-10-warning').style.display = 'none'; ">CLOSE</a>
//                     </div>
//                 </div>
//             </div>
//         `);

//         $('#iOS-10-warning a').on( 'click', function(event) {
//             sessionStorage.setItem('ios10_detect', 'true')
//         } );

//     }

// }







